var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgList = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.58333 4H14.25M5.58333 8H14.25M5.58333 12H14.25M2.25 4H2.25667M2.25 8H2.25667M2.25 12H2.25667",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgList, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/list.1ee2c1b2.svg";
export { ForwardRef as ReactComponent };